import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import './index.css';
import AppRouter from "./Routes";

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container)



try {
    root.render(<AppRouter/>)
} catch (e) {
    const queryParams = window.location.href.split('?')[1]
    window.location.assign(`https://wi-fi.netbynet.ru/internal?${queryParams}`)
}